{
  "__schema": {
    "queryType": { "name": "Query", "kind": "OBJECT" },
    "mutationType": { "name": "Mutation", "kind": "OBJECT" },
    "subscriptionType": null,
    "types": [
      {
        "kind": "OBJECT",
        "name": "AccountAccessMutationResponse",
        "fields": [
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "MinimalUser", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Application",
        "fields": [
          {
            "name": "accessGrantedOrganizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "accessGrantedOrganizationsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApplicationAccessGrantedOrganizationsConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "accessGrantedProfiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "accessGrantedProfilesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApplicationAccessGrantedProfilesConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "clientId",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "licensedOrganizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "licensedOrganizationsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApplicationLicensedOrganizationsConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "name",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "uri", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationAccessGrantedOrganizationsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ApplicationAccessGrantedOrganizationsRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationAccessGrantedOrganizationsRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationAccessGrantedProfilesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ApplicationAccessGrantedProfilesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationAccessGrantedProfilesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationAggregateSelection",
        "fields": [
          {
            "name": "clientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "IDAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "count",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "uri",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "uuid",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "IDAggregateSelection", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationEdge",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Application", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationLicensedOrganizationsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ApplicationLicensedOrganizationsRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationLicensedOrganizationsRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "LicenseProperties", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "ApplicationEdge", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AuditEvent",
        "fields": [
          {
            "name": "action",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "actorId", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "actorType", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "expiresAt", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "id",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "loginCid", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "metadata", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "occurredAt",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "sessionUid", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "source",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "targetId", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "targetType", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "tenantId", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "user",
            "type": { "kind": "OBJECT", "name": "User", "ofType": null },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "userConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "AuditEventUserConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AuditEventUserConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AuditEventUserRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AuditEventUserRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "User", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AuthClient",
        "fields": [
          {
            "name": "clientId",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "clientName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "clientSecret", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "grantTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            },
            "args": []
          },
          {
            "name": "idTokenSignedResponseAlg",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          { "name": "logoUri", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "policyUri", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "postLogoutRedirectUris",
            "type": {
              "kind": "LIST",
              "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
            },
            "args": []
          },
          {
            "name": "redirectUris",
            "type": {
              "kind": "LIST",
              "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
            },
            "args": []
          },
          {
            "name": "responseTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            },
            "args": []
          },
          { "name": "scope", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "tksExtensionConsentOptional",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          {
            "name": "tksExtensionLicenseOptional",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          {
            "name": "tksExtensionPkceOptional",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          {
            "name": "tokenEndpointAuthMethod",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "tosUri", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CollaborationProperties",
        "fields": [
          { "name": "sourceOrganization", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "status",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateApplicationsMutationResponse",
        "fields": [
          {
            "name": "applications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Application", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateInfo", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateAuthClientsMutationResponse",
        "fields": [
          {
            "name": "authClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "AuthClient", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateFederatedClientsMutationResponse",
        "fields": [
          {
            "name": "federatedClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "FederatedClient", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateInfo", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateGroupsMutationResponse",
        "fields": [
          {
            "name": "groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateInfo", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateInfo",
        "fields": [
          {
            "name": "nodesCreated",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "relationshipsCreated",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateOrganizationsMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "organizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProfileSharesMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "profileShares",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "ProfileShare", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProfilesFromProfileSharesMutationResponse",
        "fields": [
          {
            "name": "profiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "MinimalProfile", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProfilesMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "profiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreatePropertiesMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateUsersMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "User", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CustomDeleteInfo",
        "fields": [
          {
            "name": "nodesDeleted",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DateTimeAggregateSelection",
        "fields": [
          { "name": "max", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "min", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteInfo",
        "fields": [
          {
            "name": "nodesDeleted",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "relationshipsDeleted",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FederatedClient",
        "fields": [
          { "name": "clientId", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "clientSecret", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "customIdClaims",
            "type": {
              "kind": "LIST",
              "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
            },
            "args": []
          },
          {
            "name": "issuer",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "label",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "name",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "responseTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            },
            "args": []
          },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FederatedClientAggregateSelection",
        "fields": [
          {
            "name": "clientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "clientSecret",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "count",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "issuer",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "uuid",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "IDAggregateSelection", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FederatedClientEdge",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "FederatedClient", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FederatedClientProperties",
        "fields": [
          { "name": "birthdate", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "customId",
            "type": {
              "kind": "LIST",
              "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
            },
            "args": []
          },
          {
            "name": "email",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "emailVerified",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "familyName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "gender", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "givenName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "locale", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "name", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "picture", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "preferred_username", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "sub", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FederatedClientsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "FederatedClientEdge", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GlobalSubject",
        "fields": [
          {
            "name": "country",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "states",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            },
            "args": []
          },
          {
            "name": "subject",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Group",
        "fields": [
          {
            "name": "incomingRoles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "UNION", "name": "RoleTarget", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "incomingRolesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "GroupIncomingRolesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "name",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "organization",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "organizationConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "GroupOrganizationConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "profiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "profilesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "GroupProfilesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "propertiesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "GroupPropertiesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          { "name": "publicVisible", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupAggregateSelection",
        "fields": [
          {
            "name": "count",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "uuid",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "IDAggregateSelection", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupEdge",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupIncomingRolesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GroupIncomingRolesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupIncomingRolesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "UNION", "name": "RoleTarget", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "RoleNames", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupOrganizationConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GroupOrganizationRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupOrganizationRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupProfilesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GroupProfilesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupProfilesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupPropertiesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GroupPropertiesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupPropertiesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PropertiesScope", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "GroupEdge", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "IDAggregateSelection",
        "fields": [
          { "name": "longest", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "shortest", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LicenseProperties",
        "fields": [
          {
            "name": "licensedModules",
            "type": {
              "kind": "LIST",
              "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
            },
            "args": []
          },
          { "name": "notAfter", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "notBefore", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "tecartContractId", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MinimalOrganization",
        "fields": [
          {
            "name": "collaborationAdmins",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "MinimalProfile", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "collaborationSourceOrganization",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          {
            "name": "collaborationStatus",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          {
            "name": "groupAdmins",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "MinimalProfile", "ofType": null }
                }
              }
            },
            "args": []
          },
          { "name": "name", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MinimalProfile",
        "fields": [
          { "name": "email", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "firstName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "lastName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MinimalProfileShare",
        "fields": [
          {
            "name": "organization",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "MinimalOrganization", "ofType": null }
            },
            "args": []
          },
          {
            "name": "profile",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "MinimalProfile", "ofType": null }
            },
            "args": []
          },
          {
            "name": "sharedWithOrganization",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "MinimalOrganization", "ofType": null }
            },
            "args": []
          },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MinimalProfileShareEdge",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "MinimalProfileShare", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MinimalProfileSharesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "MinimalProfileShareEdge", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MinimalUser",
        "fields": [
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Mutation",
        "fields": [
          {
            "name": "createApplications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateApplicationsMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "createAuthClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateAuthClientsMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "createFederatedClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateFederatedClientsMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "createGroups",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateGroupsMutationResponse", "ofType": null }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "createOrganizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateOrganizationsMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "createProfileShares",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateProfileSharesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "createProfiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateProfilesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "createProfilesFromProfileShares",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateProfilesFromProfileSharesMutationResponse",
                "ofType": null
              }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "createProperties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreatePropertiesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "createUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CreateUsersMutationResponse", "ofType": null }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "deleteApplications",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DeleteInfo", "ofType": null }
            },
            "args": [
              { "name": "delete", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "deleteAuthClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CustomDeleteInfo", "ofType": null }
            },
            "args": [
              {
                "name": "where",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "deleteFederatedClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DeleteInfo", "ofType": null }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "deleteGroups",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DeleteInfo", "ofType": null }
            },
            "args": [
              { "name": "delete", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "deleteOrganizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DeleteInfo", "ofType": null }
            },
            "args": [
              { "name": "delete", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "deleteProfileShares",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DeleteInfo", "ofType": null }
            },
            "args": [
              { "name": "delete", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "deleteProfiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DeleteInfo", "ofType": null }
            },
            "args": [
              { "name": "delete", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "deleteProperties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DeleteInfo", "ofType": null }
            },
            "args": [
              { "name": "delete", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "deleteUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DeleteInfo", "ofType": null }
            },
            "args": [
              { "name": "delete", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "mergeProfiles",
            "type": { "kind": "OBJECT", "name": "Profile", "ofType": null },
            "args": [
              { "name": "forcePrimary", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "profiles",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              }
            ]
          },
          {
            "name": "replaceGroupProperties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ReplacePropertiesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "groupUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "replaceOrganizationProperties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ReplacePropertiesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              },
              {
                "name": "organizationUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "replaceProfileProperties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ReplacePropertiesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              },
              {
                "name": "profileUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "replaceUserProperties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ReplacePropertiesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                  }
                }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "userUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "revokeInvitation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AccountAccessMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "userUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "revokePasswordReset",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AccountAccessMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "userUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "setGroupProperty",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "SetPropertyMutationResponse", "ofType": null }
            },
            "args": [
              {
                "name": "groupUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "name",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "value",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "setImpersonateOnly",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AccountAccessMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "impersonateOnly",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "userUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "setOrganizationProperty",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "SetPropertyMutationResponse", "ofType": null }
            },
            "args": [
              {
                "name": "name",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "organizationUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "value",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "setProfileProperty",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "SetPropertyMutationResponse", "ofType": null }
            },
            "args": [
              {
                "name": "name",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "profileUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "value",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "setUserProperty",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "SetPropertyMutationResponse", "ofType": null }
            },
            "args": [
              {
                "name": "name",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "userUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "value",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "unsetGroupProperty",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UnsetPropertyMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "groupUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "name",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "unsetOrganizationProperty",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UnsetPropertyMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "name",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "organizationUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "unsetProfileProperty",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UnsetPropertyMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "name",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "profileUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "unsetUserProperty",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UnsetPropertyMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "name",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "scope",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "userUuid",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "updateApplications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateApplicationsMutationResponse",
                "ofType": null
              }
            },
            "args": [
              { "name": "update", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "updateAuthClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateAuthClientsMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "update",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "where",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "updateFederatedClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateFederatedClientsMutationResponse",
                "ofType": null
              }
            },
            "args": [
              { "name": "update", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "updateGroups",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateGroupsMutationResponse", "ofType": null }
            },
            "args": [
              { "name": "update", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "updateOrganizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateOrganizationsMutationResponse",
                "ofType": null
              }
            },
            "args": [
              { "name": "update", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "updatePasswords",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdatePasswordsMutationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "update",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              {
                "name": "where",
                "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            ]
          },
          {
            "name": "updateProfileShares",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateProfileSharesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              { "name": "update", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "updateProfiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateProfilesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              { "name": "update", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "updateProperties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdatePropertiesMutationResponse",
                "ofType": null
              }
            },
            "args": [
              { "name": "update", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "updateUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateUsersMutationResponse", "ofType": null }
            },
            "args": [
              { "name": "update", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Organization",
        "fields": [
          { "name": "address1", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "address2", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "address3", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "city", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "collaboratesWith",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "collaboratesWithConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganizationCollaboratesWithConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          { "name": "country", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "federatedClient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "FederatedClient", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "federatedClientConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganizationFederatedClientConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "groupsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "OrganizationGroupsConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          { "name": "imprintHtml", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "incomingRoles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "UNION", "name": "RoleTarget", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "incomingRolesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganizationIncomingRolesConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "licensedApplications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Application", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "licensedApplicationsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganizationLicensedApplicationsConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "locale",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "name",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "privacyHtml", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "profiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "profilesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganizationProfilesConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "propertiesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganizationPropertiesConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          { "name": "region", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "shadowProfileGroups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "shadowProfileGroupsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganizationShadowProfileGroupsConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "shadowsProfilesTo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "shadowsProfilesToConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganizationShadowsProfilesToConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          { "name": "studentCount", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "tecartContactId", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "timezone",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "tosHtml", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "tosVersion", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "zipCode", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationAggregateSelection",
        "fields": [
          {
            "name": "address1",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "address2",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "address3",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "city",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "count",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "country",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "imprintHtml",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "locale",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "privacyHtml",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "region",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "tecartContactId",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "timezone",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "tosHtml",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "tosVersion",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "uuid",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "IDAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "zipCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationCollaboratesWithConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationCollaboratesWithRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationCollaboratesWithRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "CollaborationProperties", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationEdge",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationFederatedClientConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationFederatedClientRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationFederatedClientRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "FederatedClient", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationGroupsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationGroupsRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationGroupsRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationIncomingRolesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationIncomingRolesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationIncomingRolesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "UNION", "name": "RoleTarget", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "RoleNames", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationLicensedApplicationsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationLicensedApplicationsRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationLicensedApplicationsRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Application", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "LicenseProperties", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationProfilesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationProfilesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationProfilesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationPropertiesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationPropertiesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationPropertiesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PropertiesScope", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationShadowProfileGroupsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationShadowProfileGroupsRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationShadowProfileGroupsRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ShadowRelationProperties", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationShadowsProfilesToConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationShadowsProfilesToRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationShadowsProfilesToRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ShadowRelationProperties", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationWithCollaboratingOrganizations",
        "fields": [
          {
            "name": "collaboratesWith",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "MinimalOrganization", "ofType": null }
                }
              }
            },
            "args": []
          },
          { "name": "name", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganizationsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "OrganizationEdge", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PageInfo",
        "fields": [
          { "name": "endCursor", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "hasNextPage",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "hasPreviousPage",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "startCursor", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Profile",
        "fields": [
          { "name": "birthday", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "displayName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "displayNameShort", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "email", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "firstName",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "firstNames", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "fullName",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "grantedApplications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Application", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "groupsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfileGroupsConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "incomingRoles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "UNION", "name": "RoleTarget", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "incomingRolesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileIncomingRolesConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "lastName",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          { "name": "listName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "organization",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "organizationConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileOrganizationConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          { "name": "prefixName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "propertiesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfilePropertiesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "roles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "UNION", "name": "RoleTarget", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "rolesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfileRolesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          { "name": "salutation", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "selectName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "shortName", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "tecartPersonId", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "title", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "tosAccepted", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "tosVersion", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "user",
            "type": { "kind": "OBJECT", "name": "User", "ofType": null },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "userConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfileUserConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileAggregateSelection",
        "fields": [
          {
            "name": "count",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "firstNames",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "prefixName",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "salutation",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "shortName",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "tecartPersonId",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "tosAccepted",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DateTimeAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "tosVersion",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "uuid",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "IDAggregateSelection", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileEdge",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileGroupsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfileGroupsRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileGroupsRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileIncomingRolesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfileIncomingRolesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileIncomingRolesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "UNION", "name": "RoleTarget", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "RoleNames", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileOrganizationConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfileOrganizationRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileOrganizationRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfilePropertiesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfilePropertiesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfilePropertiesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PropertiesScope", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileRelationProperties",
        "fields": [
          { "name": "primary", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "shadow", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileRolesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "ProfileRolesRelationship", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileRolesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "UNION", "name": "RoleTarget", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "RoleNames", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileShare",
        "fields": [
          {
            "name": "organization",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "organizationConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileShareOrganizationConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "profile",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "profileConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileShareProfileConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "sharedWithOrganization",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "sharedWithOrganizationConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileShareSharedWithOrganizationConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileShareEdge",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfileShare", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileShareOrganizationConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfileShareOrganizationRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileShareOrganizationRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileShareProfileConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfileShareProfileRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileShareProfileRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileShareSharedWithOrganizationConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfileShareSharedWithOrganizationRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileShareSharedWithOrganizationRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileSharesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "ProfileShareEdge", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileUserConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "ProfileUserRelationship", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileUserRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "User", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfileRelationProperties", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfilesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "ProfileEdge", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PropertiesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "PropertyEdge", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PropertiesScope",
        "fields": [
          {
            "name": "scope",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PropertiesSubject",
        "possibleTypes": [
          { "kind": "OBJECT", "name": "Group" },
          { "kind": "OBJECT", "name": "Organization" },
          { "kind": "OBJECT", "name": "Profile" },
          { "kind": "OBJECT", "name": "User" }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Property",
        "fields": [
          {
            "name": "name",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "subject",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "UNION", "name": "PropertiesSubject", "ofType": null }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "subjectConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PropertySubjectConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "value",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PropertyAggregateSelection",
        "fields": [
          {
            "name": "count",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "uuid",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "IDAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PropertyEdge",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PropertyMutationProperty",
        "fields": [
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PropertySubjectConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PropertySubjectRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PropertySubjectRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "UNION", "name": "PropertiesSubject", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PropertiesScope", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Query",
        "fields": [
          {
            "name": "applications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Application", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "applicationsAggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApplicationAggregateSelection",
                "ofType": null
              }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "applicationsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ApplicationsConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": { "kind": "LIST", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "auditEvents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "AuditEvent", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "days", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "limit", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "userUuid", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "authClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "AuthClient", "ofType": null }
                }
              }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "collaboratingOrganizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganizationWithCollaboratingOrganizations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "federatedClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "FederatedClient", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "federatedClientsAggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FederatedClientAggregateSelection",
                "ofType": null
              }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "federatedClientsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "FederatedClientsConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": { "kind": "LIST", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "globalSubjects",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "GlobalSubject", "ofType": null }
                }
              }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "groupsAggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "GroupAggregateSelection", "ofType": null }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "groupsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "GroupsConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": { "kind": "LIST", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "minimalProfileShares",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "MinimalProfileShare", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "minimalProfileSharesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MinimalProfileSharesConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": { "kind": "LIST", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "organizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "organizationsAggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganizationAggregateSelection",
                "ofType": null
              }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "organizationsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "OrganizationsConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": { "kind": "LIST", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "profileShares",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "MinimalProfileShare", "ofType": null }
                }
              }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "profileSharesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfileSharesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": { "kind": "LIST", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "profiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "profilesAggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfileAggregateSelection", "ofType": null }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "profilesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfilesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": { "kind": "LIST", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "propertiesAggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PropertyAggregateSelection", "ofType": null }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "propertiesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PropertiesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": { "kind": "LIST", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "propertiesSubjects",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "UNION", "name": "PropertiesSubject", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "roleTargets",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "UNION", "name": "RoleTarget", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "User", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "usersAggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UserAggregateSelection", "ofType": null }
            },
            "args": [{ "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }]
          },
          {
            "name": "usersConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UsersConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": { "kind": "LIST", "ofType": { "kind": "SCALAR", "name": "Any" } }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReplacePropertiesMutationResponse",
        "fields": [
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "PropertyMutationProperty", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RoleNames",
        "fields": [
          {
            "name": "names",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RoleTarget",
        "possibleTypes": [
          { "kind": "OBJECT", "name": "Group" },
          { "kind": "OBJECT", "name": "Organization" },
          { "kind": "OBJECT", "name": "Profile" },
          { "kind": "OBJECT", "name": "User" }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SetPropertyMutationResponse",
        "fields": [
          {
            "name": "property",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PropertyMutationProperty", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ShadowRelationProperties",
        "fields": [
          {
            "name": "conditions",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "optIn",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StringAggregateSelection",
        "fields": [
          { "name": "longest", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "shortest", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TwoFactorMethod",
        "fields": [
          {
            "name": "name",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "type",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "User", "ofType": null }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "userConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TwoFactorMethodUserConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TwoFactorMethodUserConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TwoFactorMethodUserRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TwoFactorMethodUserRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "User", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UnsetPropertyMutationResponse",
        "fields": [
          {
            "name": "unset",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateApplicationsMutationResponse",
        "fields": [
          {
            "name": "applications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Application", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateInfo", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAuthClientsMutationResponse",
        "fields": [
          {
            "name": "authClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "AuthClient", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateFederatedClientsMutationResponse",
        "fields": [
          {
            "name": "federatedClients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "FederatedClient", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateInfo", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateGroupsMutationResponse",
        "fields": [
          {
            "name": "groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Group", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateInfo", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateInfo",
        "fields": [
          {
            "name": "nodesCreated",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "nodesDeleted",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "relationshipsCreated",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "relationshipsDeleted",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateOrganizationsMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "organizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Organization", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePasswordsMutationResponse",
        "fields": [
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "MinimalUser", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProfileSharesMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "profileShares",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "ProfileShare", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProfilesMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "profiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePropertiesMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUsersMutationResponse",
        "fields": [
          {
            "name": "info",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UpdateInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "User", "ofType": null }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "User",
        "fields": [
          {
            "name": "email",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "emailLower",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "emailVerified",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "federatedClient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "FederatedClient", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "federatedClientConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserFederatedClientConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          { "name": "impersonateOnly", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "invitationFrontendUrl",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          {
            "name": "invitationOtpValidUntil",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          { "name": "lastLogin", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "newEmail", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "newEmailOtpValidUntil",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          { "name": "passwordChangedAt", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "preferredLanguage", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          { "name": "preferredTheme", "type": { "kind": "SCALAR", "name": "Any" }, "args": [] },
          {
            "name": "profiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "profilesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UserProfilesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "propertiesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "UserPropertiesConnection", "ofType": null }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "recoveryCodesGeneratedAt",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          {
            "name": "resetPasswordOtpValidUntil",
            "type": { "kind": "SCALAR", "name": "Any" },
            "args": []
          },
          {
            "name": "twoFactorMethods",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "TwoFactorMethod", "ofType": null }
                }
              }
            },
            "args": [
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "options", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "twoFactorMethodsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserTwoFactorMethodsConnection",
                "ofType": null
              }
            },
            "args": [
              { "name": "after", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "directed", "type": { "kind": "SCALAR", "name": "Any" } },
              { "name": "first", "type": { "kind": "SCALAR", "name": "Any" } },
              {
                "name": "sort",
                "type": {
                  "kind": "LIST",
                  "ofType": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } }
                }
              },
              { "name": "where", "type": { "kind": "SCALAR", "name": "Any" } }
            ]
          },
          {
            "name": "uuid",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserAggregateSelection",
        "fields": [
          {
            "name": "count",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "invitationFrontendUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "invitationOtpValidUntil",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DateTimeAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "newEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "newEmailOtpValidUntil",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DateTimeAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "passwordChangedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DateTimeAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "preferredLanguage",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "preferredTheme",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "StringAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "recoveryCodesGeneratedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DateTimeAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "resetPasswordOtpValidUntil",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "DateTimeAggregateSelection", "ofType": null }
            },
            "args": []
          },
          {
            "name": "uuid",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "IDAggregateSelection", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserEdge",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "User", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserFederatedClientConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserFederatedClientRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserFederatedClientRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "FederatedClient", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "FederatedClientProperties", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserProfilesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "UserProfilesRelationship", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserProfilesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Profile", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "ProfileRelationProperties", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserPropertiesConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserPropertiesRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserPropertiesRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "Property", "ofType": null }
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PropertiesScope", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserTwoFactorMethodsConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserTwoFactorMethodsRelationship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserTwoFactorMethodsRelationship",
        "fields": [
          {
            "name": "cursor",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "TwoFactorMethod", "ofType": null }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UsersConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": { "kind": "OBJECT", "name": "UserEdge", "ofType": null }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": { "kind": "OBJECT", "name": "PageInfo", "ofType": null }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": { "kind": "NON_NULL", "ofType": { "kind": "SCALAR", "name": "Any" } },
            "args": []
          }
        ],
        "interfaces": []
      },
      { "kind": "SCALAR", "name": "Any" }
    ],
    "directives": []
  }
}
